export default __webpack_public_path__ + "ae80959b2fb3b0d88e0a3abc336e26be.png";